(() => {
  // Se non siamo in una pagina con product gallery, esci subito
  const gallery = document.querySelector("product-gallery");
  if (!gallery) return;

  // Listener SOLO sulla gallery (non sul document)
  gallery.addEventListener(
    "click",
    (e) => {
      const btn = e.target.closest("[data-open-4th-photo]");
      if (!btn) return;

      e.preventDefault();

      // (opzionale ma ok) verifica che ci siano almeno 4 immagini visibili
      const imgs = gallery.querySelectorAll(
        '.product-gallery__media[data-media-type="image"]:not([hidden]) > img'
      );
      if (imgs.length < 4) return;

      // Apri dalla 4ª immagine (index 3)
      gallery.dispatchEvent(
        new CustomEvent("lightbox:open", {
          bubbles: true,
          detail: { index: 3 }
        })
      );
    },
    true // capture: resta, ma ora è confinato alla gallery
  );
})();
